import { useClinicMasterProducts } from '../../apis/clinic-master-products/hooks/useClinicMasterProducts';
import { ClinicMasterProductSelectorOption } from './interface';
import { createOptions, getSelectedOptions } from './utils';

interface UseClinicMasterProductOptionsProps {
  clinicId: string;
  selectedClinicMasterProductsIds?: string[];
}

interface UseClinicMasterProductOptionsReturn {
  options: ClinicMasterProductSelectorOption[];
  selectedOptions?: ClinicMasterProductSelectorOption[];
}

function useClinicMasterProductOptions({
  clinicId,
  selectedClinicMasterProductsIds
}: UseClinicMasterProductOptionsProps): UseClinicMasterProductOptionsReturn {
  const { clinicMasterProducts } = useClinicMasterProducts(clinicId, 0, 50);
  const selectedOptions = getSelectedOptions(clinicMasterProducts, selectedClinicMasterProductsIds);

  return {
    options: createOptions(clinicMasterProducts),
    selectedOptions
  };
}

export default useClinicMasterProductOptions;
